import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class NumberField extends Component {
    render() {
        const {
                id,
                name,
                value,
                label,
                description,
                hint,
                warning,
                unit,
                children,
                showErrors,
                errors,
                showIf,
                ...inputProps
            } = this.props,

            invalid = !!errors,
            fieldClasses = classNames('ht-field ht-numberfield', {
                'ht-numberfield--invalid': invalid,
                'ht-numberfield--m': unit === 'm',
                'ht-numberfield--m2': unit === 'm2',
                'ht-numberfield--perc': unit === '%',
                'ht-numberfield--disabled': inputProps.disabled
            }),
            inputClasses = classNames('bx--text-input bx--text__input', {
                'bx--text-input--invalid': invalid
            }),
            helperText = description && description() ? description() : false;

        return (
            <div className={fieldClasses}>
                <div className='bx--form-item bx--text-input-wrapper'>
                    {label && (
                        <label htmlFor={id} className='bx--label'>
                            {label}
                        </label>
                    )}
                    {helperText && (
                        <div className='bx--form__helper-text'>
                            {helperText}
                        </div>
                    )}
                    <div
                        className='bx--text-input__field-wrapper'
                        data-invalid={invalid}
                    >
                        <input
                            pattern='[-+]?[0-9]*[.,]?[0-9]+'
                            className={inputClasses}
                            data-invalid={invalid}
                            aria-invalid={invalid}
                            aria-describedby={
                                invalid ? `${name}-error-msg` : null
                            }
                            {...inputProps}
                            id={id}
                            name={name}
                            value={value}
                            step='any'
                            type='number'
                            onWheelCapture={e => {
                                e.target.blur();
                            }}
                        />
                        {unit && (
                            <span className='ht-numberfield-unit'>{unit}</span>
                        )}
                        {children}
                    </div>
                    {warning && <p className='ht-field-warning'>{warning}</p>}
                    {hint && <p className='ht-field-hint'>{hint}</p>}
                    {showErrors && invalid && errors && (
                        <div
                            className='bx--form-requirement'
                            id={`${name}-error-msg`}
                        >
                            {errors}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

NumberField.defaultProps = {
    unit: null,
    description: () => {},
    label: '',
    value: 0,
    errors: '',
    disabled: false,
    showErrors: true
};

NumberField.propTypes = {
    id: PropTypes.string.isRequired,
    unit: PropTypes.oneOf(['m', 'm2', '%', null]),
    description: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    errors: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
};

export default NumberField;
